export default __webpack_public_path__ + "static/media/querelle_detail2.22d3dbd1.jpg";